/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomButtonGroup, CustomTextArea, SelectDropDown, useAppDispatch, useAppSelector, useEffectOnce } from '../../../globalUtils/globalExports';
import { fetchAlarmTypeOfNotification, fetchRecipientListReferenceData, getAdvanceRuleEngineReducer, getReferenceDataReducer } from '../../../rmsReduxStore/reduxExports';
import { cloneDeep, isEqual } from 'lodash';
import  {ExecutionPlan, SendNotificationAction } from './ExecutionPlan';
import { getOrgId } from '../AdvanceRuleEngineForm';
import './SendNotificationSidePopover.css'


interface SendNotificationSidePopoverprops {
    sendNotification: null | SendNotificationAction;
    handleClose: () => void;
    executionPlan: ExecutionPlan;
    handleUpdateExecutionPlan: Function;
    ifOrElse: string;
    nodeId: string;
    parentNodeId: string;
}

const SendNotificationSidePopover = ({
    sendNotification,
    handleClose,
    executionPlan,
    handleUpdateExecutionPlan,
    ifOrElse,
    nodeId,
    parentNodeId
}: SendNotificationSidePopoverprops) => {
    const dispatch = useAppDispatch();
    const { typeOfNotificationReferenceData, ruleEngineActionControlSendNotificationReferenceData } = useAppSelector(getReferenceDataReducer);
    const { advanceRuleEngineFormRedux } = useAppSelector(getAdvanceRuleEngineReducer);
    const [popOverData, setPopOverData] = useState<SendNotificationAction>({
        type: 'Send Notification',
        nodeId,
        notificationType: '',
        recipients: [],
        emailContent: '',
        recipientsName: []
    });
    const [initialPopOverData, setInitialPopOverData] = useState<SendNotificationAction>({
        type: 'Send Notification',
        nodeId,
        notificationType: '',
        recipients: [],
        emailContent: '',
        recipientsName: []
    })

    const orgId = getOrgId();


    useEffectOnce(() => {
        dispatch(fetchAlarmTypeOfNotification(false))
        dispatch(fetchRecipientListReferenceData({ orgId: orgId }))
    })



    useEffect(() => {
        if (sendNotification) {
            setPopOverData(sendNotification)
            setInitialPopOverData(sendNotification)
        }
    }, [sendNotification])


    const disableButton = useCallback(() => {
        if (isEqual(initialPopOverData, popOverData))
            return true;
        else
            return !(popOverData && popOverData.notificationType.length > 0 && popOverData.recipients.length > 0)
    }, [popOverData, setPopOverData])

    const btnsList = useMemo(() => {
        return [
            {
                buttonText: 'Save',
                buttonId: 'add',
                btnClassName: disableButton() ? 'primary__btn disabled' : 'primary__btn',
                handleClick: (): void => {
                    const formattedData: SendNotificationAction = {
                        type: 'Send Notification',
                        nodeId: nodeId,
                        notificationType: popOverData?.notificationType,
                        recipients: popOverData?.recipients,
                        emailContent: popOverData?.emailContent,
                        recipientsName : popOverData?.recipientsName,
                    }

                    const executionData = cloneDeep(executionPlan);
                    const actionIdx = executionData?.actions?.findIndex((executionDataItem) => executionDataItem.flowType === ifOrElse && executionDataItem?.parentNodeId === parentNodeId);
                    const actionItemIndex = executionData?.actions?.[actionIdx]?.list?.findIndex(item => item?.type === 'Send Notification');
                    if(actionItemIndex === -1){
                        executionData?.actions?.[actionIdx]?.list?.push(formattedData)
                    }else{
                        executionData.actions[actionIdx].list[actionItemIndex] = formattedData
                    }

                    handleUpdateExecutionPlan(executionData);
                    handleClose();
                },
                isDisabled: disableButton(),
                buttonVariant: 'filled',
            },
            {
                buttonText: 'Cancel',
                buttonId: 'cancel',
                btnClassName: 'secondary__btn',
                handleClick: (): void => {
                    handleClose()
                },
                isDisabled: false,
                buttonVariant: 'outlined',
            },
        ];
    }, [popOverData]);

    return (
        <>
            <div className='advance__rule__engine__send__notification__side__popover'>
                <hr className="custom-hr" />
                <div className='advance__rule__engine__send__notification__side__popover__wrapper'>
                    <div>
                        <div className='advance__rule__engine__send__notification__side__popover__row__label'>
                            Notification Mode*
                        </div>
                        <div>
                            <SelectDropDown
                                selectDropDownId={'advance__rule__engine__send__notification__mode__dropdown'}
                                handleSelectOptionChange={(val) => {
                                    let emailContent = popOverData?.emailContent;
                                    if(val?.label === 'SMS') emailContent = '';
                                    setPopOverData({
                                        ...popOverData,
                                        notificationType: val?.label,
                                        emailContent
                                    });
                                }}
                                selectOptions={typeOfNotificationReferenceData ?? []}
                                isMultiSelect={false}
                                selectValue={{ id: popOverData?.notificationType, label: popOverData?.notificationType }}
                            />
                        </div>
                    </div>
                    <div>
                        <div className='advance__rule__engine__send__notification__side__popover__row__label'>
                            Recipients*
                        </div>
                        <div>
                            <SelectDropDown
                                selectDropDownId={'advance__rule__engine__send__notification__recipient__dropdown'}
                                handleSelectOptionChange={(val) => {
                                    const data = cloneDeep(popOverData);
                                    data.recipients = val?.map((item)=> item.id);
                                    data.recipientsName = val?.map((item)=> item.label);
                                    setPopOverData(data);
                                }}
                                selectOptions={ruleEngineActionControlSendNotificationReferenceData ?? []}
                                isMultiSelect={true}
                                selectValue={ruleEngineActionControlSendNotificationReferenceData?.filter((refData) => popOverData?.recipients?.includes(refData?.id)) ?? null }
                                showMultipleOptionInside={true}
                            />
                        </div>
                    </div>
                    {
                    popOverData?.notificationType && popOverData?.notificationType!='SMS' && <div className='advance__rule__engine__send__notification__email__content__wrap'>
                        <div className='advance__rule__engine__send__notification__side__popover__row__label'>
                            Email Content
                        </div>   
                        <div className='advance__rule__engine__send__notification__email__content-container'>
                                <div className='advance__rule__engine__send__notification__email__content-row'>
                                    <span className='send__notification__email__content-label-dark'>Subject: </span>
                                    <span className='send__notification__email__content-label'>
                                        Exicom SPIN RMS Alert in {'[Customer] charger [Charger ID]'}
                                    </span>
                                </div>
                                <div className='advance__rule__engine__send__notification__email__content-row' >
                                    <span className='send__notification__email__content-label'>{'Dear [Recipients\'s Name]'} </span>
                                </div>
                                <div className='advance__rule__engine__send__notification__email__content-row' >
                                    <span className='send__notification__email__content-label'>Exicom SPIN RMS: </span>
                                    <span className='send__notification__email__content-label'>Rule Engine has detected an alert from a charger.</span>
                                </div>
                                <div className='advance__rule__engine__send__notification__email__content-row-2' style={{marginTop: '20px',marginBottom:'5px'}}>
                                    <span className='send__notification__email__content-label-large-dark'>Alert Details:</span>
                                </div>
                                <div className='advance__rule__engine__send__notification__email__content-row-2' >
                                    <span className='send__notification__email__content-label-dark'>Alert name:</span>
                                    <span className='send__notification__email__content-label-blue'>{advanceRuleEngineFormRedux?.name ?? '[Rule name]'}</span>
                                </div>
                                <div className='advance__rule__engine__send__notification__email__content-row-2' >
                                    <span className='send__notification__email__content-label-dark'>Time:</span>
                                    <span className='send__notification__email__content-label'>{'[Fire Time]'}</span>
                                </div>
                                <div className='advance__rule__engine__send__notification__email__content-row-2'>
                                    <span className='send__notification__email__content-label-dark'>Charger:</span>
                                    <span className='send__notification__email__content-label-blue'>{'[Charger ID]'}</span>
                                    <span className='send__notification__email__content-label'>{', [Charging Station], [Customer], [Location]'}</span>
                                </div>
                                <div className='advance__rule__engine__send__notification__email__content-box'>
                                    <span className='send__notification__email__content-label-grey'>Custom Content:</span>
                                    <CustomTextArea 
                                        inputFieldId={'advance__rule__engine__custom__mail__content'} 
                                        isRequired={false} 
                                        inputValue={popOverData?.emailContent ?? ''}
                                        handleInputChange={
                                            (event)=>{
                                                const data = cloneDeep(popOverData);
                                                data.emailContent = event?.target?.value;
                                                setPopOverData(data);
                                            }
                                        }
                                    />
                                </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div className='advance__rule__engine__side__popover-footer'>
                <CustomButtonGroup
                    buttonsList={btnsList}
                    buttonGroupClassName='button__group__footer' />
            </div>
        </>
    )
}

export default SendNotificationSidePopover;